<template>
  <div class="logAudit">
   <div>
   <img class="sd-body" src="../../../assets/images/SD-WAN-all.png">
 </div>

   <div class="tittle-white">
        
    </div> 
        

 
    
    
    
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  }
};
</script>
<style lang="scss" scoped>




.tittle-white{
  width: 100%;
	height: 50px;
  color:#ffffff;
}

.sd-body{
    display: block;
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
}











// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 260px;
    background-image: url("../../../assets/images/SD-WAN-all.png");
  }
  
}
</style>